import DataService from '@/service/DataService'
import router from '@/router'

const benutzer = JSON.parse(localStorage.getItem('benutzer'))
const hilfeAngefordertStatus = JSON.parse(localStorage.getItem('hilfeAngefordertStatus'))

const state = benutzer
  ? { status: { angemeldet: true }, benutzer, alleBenutzer: null, bild: null, hilfeAngefordertStatus }
  : { status: {}, benutzer: null, alleBenutzer: null, bild: null, hilfeAngefordertStatus: false }

const getters = {
  benutzerStatus: (state) => state.status,
  hilfeAngefordertStatus: (state) => state.hilfeAngefordertStatus,
  benutzerBild: (state) => state.bild,
  benutzer: (state) => state.benutzer,
  alleBenutzer: (state) => state.alleBenutzer
};

const actions = {
  // GET
  fetchBenutzer({commit}) {
    commit('GETBENUTZERDATAREQUEST')

    return DataService.getBenutzer()
      .then(res => {
        commit('GETBENUTZERDATAREQUEST', res.data)
      })
      .then(() => {location.reload()})
      .catch(err => {
        commit('GETBENUTZERDATAREQUEST', err)
      })
  },
  abmelden({ commit, state }) {
    return DataService.logout(state.benutzer.id)
      .then(() => {
        caches.keys().then(cacheNames => {
          cacheNames.forEach(cache => {
            if (cache === 'fotoalbum-cache' || cache === 'api-cache') {
              caches.delete(cache)
            }
          })
        }).then(() => {
          commit('LOGOUT')
          localStorage.clear();
          location.reload();
        })
      })
      .catch(() => {
        // commit('LOGOUTFAILURE', err)
        caches.keys().then(cacheNames => {
          cacheNames.forEach(cache => {
            if (cache === 'fotoalbum-cache' || cache === 'api-cache') {
              caches.delete(cache)
            }
          })
        }).then(() => {
          commit('LOGOUT')
          localStorage.clear();
          location.reload();
        })
      })
  },
  getAllBenutzer({ commit }) {
    commit('GETALLBENUTZERREQUEST')

    return DataService.getAllUsers()
      .then(res => {
        commit('GETALLBENUTZERSUCCESS', res.data)
      })
      .catch(err => {
        commit('GETALLBENUTZERFAILURE', err)
      })
  },
  getBenutzerBild({ commit }) {
    commit('GETBENUTZERBILDREQUEST')

    return DataService.getUserImage()
      .then(res => {
        commit('GETBENUTZERBILDSUCCESS', res.data)
      })
      .catch(err => {
        commit('GETBENUTZERBILDFAILURE', err)
      })
  },
  fetchZuhauseStatus({ commit }) {
    commit('GETZUHAUSESTATUSREQUEST')

    return DataService.getZuhauseStatus()
      .then(res => {
        commit('GETZUHAUSESTATUSSUCCESS', res.data)
      })
      .catch(err => {
        commit('GETZUHAUSESTATUSFAILURE', err)
      })
  },
  passwortVergessen({ commit }, email) {
    commit('PASSWORTVERGESSENREQUEST')

    return DataService.resetPasswort(email)
      .then(res => {
        commit('PASSWORTVERGESSENSUCCESS', res.data)
      })
      .catch(() => {
        commit('PASSWORTVERGESSENFAILURE', 'Es ist ein Fehler unerwarteter Fehler aufgetreten. Bitte versuche es später noch ein mal.')
      })
  },
  hilfeSmsToFavoriten({ commit }) {
    commit('HILFESMSTOFAVORITENREQUEST')

    return DataService.sendHilfeSmsToFavoriten()
      .then(res => {
        commit('HILFESMSTOFAVORITENSUCCESS', res.data)
      })
      .catch(err => {
        commit('HILFESMSTOFAVORITENFAILURE', err)
      })
  },

  // POST
  registrieren({ commit }, benutzer) {
    commit('REGISTERREQUEST')

    return DataService.register(benutzer)
      .then(res => {
        commit('REGISTERSUCCESS', res.data)
      }).catch(() => {
        commit('REGISTERFAILURE', "Die E-Mail-Adresse wird bereits verwendet")
      })
  },
  anmelden({ commit }, benutzer) {
    commit('LOGINREQUEST')

    return DataService.login(benutzer)
      .then(res => {
        commit('LOGINSUCCESS', res.data)

        if (res.data.funktionen.sicherheit === 1) router.push('/');
        else if (res.data.funktionen.kommunikation === 1) router.push('/kommunikation');
        else if (res.data.funktionen.unterhaltung === 1) router.push('/unterhaltung');
        else if (res.data.funktionen.gesundheit === 1) router.push('/gesundheit');
        else router.push('/profil')
      }).catch(err => {
        if (err.response) {
          commit('LOGINFAILURE', err.response.data)
        } else {
          commit('LOGINFAILURE', err)
        }

        localStorage.clear()
      })
  },
  refresh({ commit, state }) {
    commit('REFRESHREQUEST')

    return DataService.refreshToken({ token: state.benutzer.token, refreshToken: state.benutzer.refreshToken })
      .then(res => {
        commit('REFRESHSUCCESS', res.data)
        return res
      })
      .catch(err => {
        commit('REFRESHFAILURE', err)
      })
  },
  uploadBenutzerBild({ commit }, image) {
    commit('UPLOADBENUTZERBILDREQUEST')

    return DataService.uploadUserImage(image)
      .then(res => {
        commit('UPLOADBENUTZERBILDSUCCESS', res.data)
        localStorage.setItem('benutzerBild', JSON.stringify(res.data))
      })
      .catch(err => {
        commit('UPLOADBENUTZERBILDFAILURE', err)
      })
  },
  favoritenEmailSenden({ commit }, message) {
    commit('EMAILSENDENREQUEST')

    return DataService.sendEmailToFavoriten(message)
      .then(res => {
        commit('EMAILSENDENSUCCESS', res.data)
      })
      .catch(err => {
        commit('EMAILSENDENFAILURE', err)
      })
  },
  kontaktEmailSenden({ commit }, data) {
    commit('EMAILSENDENREQUEST')

    const message = data.message
    const kontaktId = data.kontaktId

    return DataService.sendEmailtoKontakt(kontaktId, message)
      .then(res => {
        commit('EMAILSENDENSUCCESS', res.data)
      })
      .catch(err => {
        commit('EMAILSENDENFAILURE', err)
      })
  },
  changeZuhauseStatus({ commit, state }) {
    let status = state.benutzer.istZuhause
    commit('CHANGEZUHAUSESTATUSREQUEST')

    return DataService.setZuhauseStatus(!status)
      .then(() => {
        commit('CHANGEZUHAUSESTATUSSUCCESS')
      })
      .catch(err => {
        commit('CHANGEZUHAUSESTATUSFAILURE', err)
      })
  },
  smsProvider({ commit }, smsProvider) {
    commit('SETSMSPROVIDERREQUEST')

    return DataService.setSmsProvider(smsProvider)
      .then(() => commit('SETSMSPROVIDERSUCCESS'))
      .catch(err => commit('SETSMSPROVIDERFAILURE', err))
  },


  // PUT
  updateBenutzer({ commit }, benutzer) {
    commit('UPDATEBENUTZERREQUEST')

    delete benutzer.refreshToken
    delete benutzer.token

    return DataService.updateUser(benutzer)
      .then(res => {
        commit('UPDATEBENUTZERSUCCESS', res.data)
      })
      .catch(err => {
        commit('UPDATEBENUTZERFAILURE', err)
      })
  },
  changePasswort({ commit }, changePasswort) {
    commit('CHANGEPASSWORTREQUEST')

    return DataService.updatePasswort(changePasswort)
      .then(res => {
        commit('CHANGEPASSWORTSUCCESS', res.data)
      })
      .catch(err => {
        if (err.response.data) {
          commit('CHANGEPASSWORTFAILURE', err.response.data)
        } else {
          commit('CHANGEPASSWORTFAILURE', "Es ist ein Fehler unerwarteter Fehler aufgetreten. Bitte versuche es später noch ein mal.")
        }
      })
  },
  

  // DELETE
  deleteBenutzer({ commit }, benutzerId) {
    commit('DELETEBENUTZERREQUEST')

    return DataService.deleteUser(benutzerId)
      .then(res => {
        if (res.status === 200) {
          commit('DELETEBENUTZERSUCCESS')
        }
      })
      .catch(() => {
        commit('DELETEBENUTZERFAILURE', "Es ist ein Fehler unerwarteter Fehler aufgetreten. Bitte versuche es später noch ein mal.")
      })
  },
  deleteBenutzerBild({ commit }, image) {
    commit('DELETEBENUTZERBILDREQUEST')
    
    return DataService.deleteUserImage(image)
    .then(res => {
      commit('DELETEBENUTZERBILDSUCCESS', res.data)
    })
    .catch(err => {
      commit('DELETEBENUTZERBILDFAILURE', err)
    })
  },


  // FUNKTIONEN
  changeHilfeAngefordertStatus({ commit, state }) {
    if (!state.hilfeAngefordertStatus) {
      commit('HILFEANFORDERN')
    } else {
      commit('HILFEANFORDERNRESET')
    }
  }
};

const mutations = {
  // GET
  GETBENUTZERDATAREQUEST: (state) => { state.status = { gettingBenutzerData: true}},
  GETBENUTZERDATASUCCESS: (state, res) => {
    state.staus = {}
    state.benutzer = res
    localStorage.setItem('benutzer', JSON.stringify(res))
  },
  GETBENUTZERDATAFAILURE: (state, err) => { state.status = { errMsg: err } },
  LOGOUT: (state) => {
    state.status = {},
      state.benutzer = null
  },
  LOGOUTFAILURE: (state, err) => { state.status = { errMsg: err } },
  GETALLBENUTZERREQUEST: (state) => { state.status = { gettingAllBenutzer: true } },
  GETALLBENUTZERSUCCESS: (state, res) => {
    state.status = {}
    state.alleBenutzer = res
  },
  GETALLBENUTZERFAILURE: (state, err) => {
    state.status = { errMsg: err }
    state.alleBenutzer = null
  },
  GETBENUTZERBILDREQUEST: (state) => { state.status = { gettingUserImage: true } },
  GETBENUTZERBILDSUCCESS: (state, res) => {
    state.status = {}
    state.bild = res
  },
  GETBENUTZERBILDFAILURE: (state, err) => {
    state.status = { errMsg: err }
    state.bild = null
  },
  GETZUHAUSESTATUSREQUEST: (state) => { state.status = { gettingZuhauseStatus: true } },
  GETZUHAUSESTATUSSUCCESS: (state, res) => {
    state.status = {}
    state.benutzer.istZuhause = res
    localStorage.setItem('benutzer', JSON.stringify(state.benutzer))
  },
  GETZUHAUSESTATUSFAILURE: (state, err) => { state.status = { errMsg: err } },
  PASSWORTVERGESSENREQUEST: (state) => { state.status = { resettingPassword: true } },
  PASSWORTVERGESSENSUCCESS: (state, res) => { state.status = { passwortReset: res } },
  PASSWORTVERGESSENFAILURE: (state, err) => { state.status = { errMsg: err } },
  HILFESMSTOFAVORITENREQUEST: (state) => { state.status = { sendingSmsToFavoriten: true } },
  HILFESMSTOFAVORITENSUCCESS: (state, res) => { state.status = { successMsg: res } },
  HILFESMSTOFAVORITENFAILURE: (state, err) => { state.status = { errMsg: err } },

  //POST
  REGISTERREQUEST: (state) => { state.status = { registrieren: true } },
  REGISTERSUCCESS: (state, res) => {
    state.status = { successMsg: res }
  },
  REGISTERFAILURE: (state, err) => { state.status = { errMsg: err } },
  LOGINREQUEST: (state) => { state.status = { anmelden: true } },
  LOGINSUCCESS: (state, res) => {
    state.status = {}
    state.benutzer = res
    localStorage.setItem('benutzer', JSON.stringify(res))
  },
  LOGINFAILURE: (state, err) => { state.status = { errMsg: err } },
  REFRESHREQUEST: (state) => { state.status = { refreshingToken: true } },
  REFRESHSUCCESS: (state, res) => {
    state.status = {}
    state.benutzer.token = res.token
    state.benutzer.refreshToken = res.refreshToken
    localStorage.setItem('benutzer', JSON.stringify(state.benutzer))
  },
  REFRESHFAILURE: (state, err) => { state.status = { errMsg: err } },
  UPLOADBENUTZERBILDREQUEST: (state) => { state.status = { uploadingUserImage: true } },
  UPLOADBENUTZERBILDSUCCESS: (state, res) => {
    state.status = {}
    state.bild = res
  },
  UPLOADBENUTZERBILDFAILURE: (state, err) => {
    state.status = { errMsg: err }
    state.bild = null
  },
  EMAILSENDENREQUEST: (state) => { state.status = { sendingEmail: true } },
  EMAILSENDENSUCCESS: (state) => { state.status = {} },
  EMAILSENDENFAILURE: (state, err) => { state.status = { errMsg: err } },
  CHANGEZUHAUSESTATUSREQUEST: (state) => {
    state.status = { changingZuhauseStatus: true }
    state.benutzer.istZuhause = !state.benutzer.istZuhause
    localStorage.setItem('benutzer', JSON.stringify(state.benutzer))
  },
  CHANGEZUHAUSESTATUSSUCCESS: (state) => { state.status = {} },
  CHANGEZUHAUSESTATUSFAILURE: (state, err) => {
    state.status = { errMsg: err }
    state.benutzer.istZuhause = !state.benutzer.istZuhause
  },
  SETSMSPROVIDERREQUEST: (state) => { state.status = { settingSmsProvider: true } },
  SETSMSPROVIDERSUCCESS: (state) => { state.status = {} },
  SETSMSPROVIDERFAILURE: (state, err) => { state.status = { errMsg: err } },


  // PUT
  UPDATEBENUTZERREQUEST: (state) => { state.status = { updatingUser: true } },
  UPDATEBENUTZERSUCCESS: (state, res) => {
    state.status = {}

    if (state.benutzer.id === res.id) {
      state.benutzer = res
      localStorage.setItem('benutzer', JSON.stringify(res))
    }

    if (state.alleBenutzer !== null) {
      let index = state.alleBenutzer.findIndex(b => b.id === res.id)
      if (index !== null) {
        state.alleBenutzer[index] = res
      } else {
        state.alleBenutzer.push(res);
      }

      localStorage.setItem('alleBenutzer', JSON.stringify(res))
    }
  },
  UPDATEBENUTZERFAILURE: (state, err) => { state.status = { errMsg: err } },
  CHANGEPASSWORTREQUEST: (state) => { state.status = { changingPasswort: true } },
  CHANGEPASSWORTSUCCESS: (state, res) => {
    state.status = {}
    state.benutzer.token = res.token
    state.benutzer.refreshToken = res.refreshToken
    localStorage.setItem('benutzer', JSON.stringify(state.benutzer))
  },
  CHANGEPASSWORTFAILURE: (state, err) => { state.status = { errMsg: err } },
  

  // DELETE
  DELETEBENUTZERREQUEST: (state) => { state.status = { deletingUser: true } },
  DELETEBENUTZERSUCCESS: (state) => {
    state.benutzer = null
    state.status = {}

    localStorage.clear();
    location.reload();
  },
  DELETEBENUTZERFAILURE: (state, err) => { state.status = { errMsg: err } },

  DELETEBENUTZERBILDREQUEST: (state) => { state.status = { deletingUserImage: true } },
  DELETEBENUTZERBILDSUCCESS: (state) => {
    state.status = {}
    state.bild = null
  },
  DELETEBENUTZERBILDFAILURE: (state, err) => {
    state.status = { errMsg: err }
    state.bild = null
  },

  // FUNCTIONS
  HILFEANFORDERN: (state) => {
    state.hilfeAngefordertStatus = true
    localStorage.setItem('hilfeAngefordertStatus', JSON.stringify(state.hilfeAngefordertStatus))
  },
  HILFEANFORDERNRESET: (state) => {
    state.hilfeAngefordertStatus = false
    localStorage.setItem('hilfeAngefordertStatus', JSON.stringify(state.hilfeAngefordertStatus))
  }
};

export default {
  state,
  getters,
  actions,
  mutations
}
